import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { signup } from '@/js/lib/api/signup/shop';
import { checkEmailExistence } from '@/js/lib/api/validate';
import { scrollToError } from '@/js/lib/helper/validate';
import { confirm, info, loading } from '@/js/lib/ui';
import FormWrapHasTitle from '@/js/components/organisms/FormWrapHasTitle.vue';
import FormSection from '@/js/components/organisms/FormSection.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';
import IButton from '@/js/components/molecules/IButton.vue';

interface FormData {
  shopName: string;
  email: string;
  password: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopForm',
  props: {
    helpLink: null
  },
  setup(__props: any) {


const observer = ref();
const emailRef = ref();
const formData = ref<FormData>({
  shopName: '',
  email: '',
  password: '',
});
const isShowCarrierMailAlert = computed(() => /.+@.*(docomo|softbank|ezweb|vodafone|disney|emobile|ymobile|willcom)/.test(formData.value.email));
const onSubmit = async () => {
  const isValid = await observer.value.validate();
  if (!isValid) {
    scrollToError();
    return;
  }
  const emailExistence = await checkEmailExistence({ email: formData.value.email });
  if (emailExistence !== true) {
    emailRef.value.$refs.provider.applyResult({
      errors: [emailExistence],
    });
    scrollToError();
    return;
  }

  if ((await confirm('ショップを開設します。よろしいですか？')) !== true) {
    return;
  }

  loading({
    asyncFunc: async () => {
      try {
        await signup({
          email: formData.value.email,
          password: formData.value.password,
          shopName: formData.value.shopName,
        });
        window.location.href = '/your/account';
      } catch (error) {
        console.error(error);
        info('ショップを開設できませんでした。', { fadeOut: false });
      }
    },
  });
};

return { __sfc: true,observer, emailRef, formData, isShowCarrierMailAlert, onSubmit, FormWrapHasTitle, FormSection, ITextField, IButton }
}

})